const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/assets-common/api-factory');
const serviceFactory = require('../resources/assets-common/service-factory');
const routeAdderFactory = require('../resources/assets-common/route-adder-factory');
const parsePosition = require('../resources/assets-common/parse-position');
const parseTransaction = require('../resources/assets-common/parse-transaction');
const flow = require('lodash/fp/flow');
const filter = require('lodash/fp/filter');
const merge = require('lodash/fp/merge');
const remove = require('lodash/fp/remove');
const pathResult = require('../resources/path-result');

function parseMMIPosition(position) {
  const isFund = position.psInvCtg.startsWith('Fund -');
  return merge(
    parsePosition(position),
    {
      isFund,
      positionType: isFund ? 'funds' : 'deposits',
      accruedInterest: position.psAccIntRefCcy,
      maturityDate: position.psMtrDte,
      maturityInterest: position.psTotIntRefCcy,
      maturityInterestPosCcy: position.psTotIntPosCcy,
      maturityInterestPandI: position.psPiRefccy,
      maturityInterestPandIPosCcy: position.psPiPosccy,
      amount: position.psDepAmt,
    }
  );
}

function parseMMITransaction(transaction) {
  return merge(
    parseTransaction(transaction),
    {
      currency: transaction.ccyTrade,
      amount: transaction.netAmtPaymentCcy,
    }
  );
}

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/money-market/${apiConfig.apiversion}/`,
    authToken: config.authToken,
    assetCategory: '3',
    positionsUrl: 'money-market-positions',
    transactionsUrl: 'money-market-transactions',
    valueMovementUrl: 'money-market-value-movement',
  });

  const service = serviceFactory({
    api,
    parsePosition: parseMMIPosition,
    parseTransaction: parseMMITransaction,
  });

  function filterFundOrDeposit(key) {
    const isFund = pos => pos.isFund;
    if (key === 'funds') return filter(isFund);
    return remove(isFund);
  }

  const path = '[{keys:metaData}].portfoliosById[{keys:portfolioId}].mmInstruments';

  return flow(
    routeAdderFactory({ assetType: 'mmInstruments', service }),
    app => app
      .match(`${path}.positions["funds","deposits"].length`,
        requests => Promise.all(requests.map(({ req, res }) =>
          service.getPositions(req.params.portfolioId, req.params.metaData)
            .then(filterFundOrDeposit(req.params[3]))
            .then(positions => res.value(positions.length))
            .catch(res.error)
        ))
      )
      .match(`${path}.positions["funds","deposits"][{integers:i}][{keys:k1}][{keys:k2}]`,
        requests => Promise.all(requests.map(({ req, res }) =>
          service.getPositions(req.params.portfolioId, req.params.metaData)
            .then(filterFundOrDeposit(req.params[3]))
            .then(pathResult([req.params.i, req.params.k1, req.params.k2], res))
            .catch(res.error)
        ))
      )
      .match(`${path}.positions["funds","deposits"][{integers:i}][{keys:k}]`,
        requests => Promise.all(requests.map(({ req, res }) =>
          service.getPositions(req.params.portfolioId, req.params.metaData)
            .then(filterFundOrDeposit(req.params[3]))
            .then(pathResult([req.params.i, req.params.k], res))
            .catch(res.error)
        ))
      )
  );
}

module.exports = addRoutes;
